import { useNavigate } from "react-router-dom";
import ServiceForm from "./ServiceForm";
import Header from "./Header";
import desktop from "../assets/images/Desktop.png";
import mobile from "../assets/images/Mobile.png";

export default function FormPage() {
    const navigate = useNavigate();

    return (
        <>
            <Header/>
            <div className="main-container">
                <div className="main-image">
                    <img src={desktop} className="background-image" alt=""/>
                    <img src={mobile} className="background-image-mobile" alt=""/>
                </div>
            </div>
            <div className="form-outer-container">
                <div className="form-bg">
                    <ServiceForm onSuccess={() => navigate("/dziekujemy")}/>
                </div>
            </div>
        </>
    );
}
